const decimalFormatter = new Intl.NumberFormat('en-AU', {
  style: 'decimal',
});

export default function formatDecimal(value: number) {
  return decimalFormatter.format(value);
}
